import { Filters } from './Filters';
import './Resume.css';
import { ComparePerMonthPerYearTotal } from './ComparePerMonthPerYearTotal';
import { useChartsDataContext } from './hooks/useChartsDataContext';
import Loading from '../../Dashboards/Common/Loading';
import { Indicators } from './Indicators';

export const Resume = () => {
    const { state } = useChartsDataContext();

    return (
        <section className="content pr-3 pl-3" style={{ marginTop: '30px' }}>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div
                            className="card card-outline"
                            style={{ borderTop: `3px solid` }}
                        >
                            <div
                                className="card-header"
                                style={{ borderBottom: '0' }}
                            >
                                <h3 className="card-title">
                                    <i className={`fa-solid  mr-1`}></i>
                                    Resumo Anual
                                </h3>
                            </div>
                            <Filters />
                            <div
                                className="charts-container-dashboards"
                                style={{ padding: '0px 20px 20px' }}
                            >
                                {state.isLoading && <Loading />}
                                {!state.isLoading && (
                                    <>
                                        <Indicators />
                                        <ComparePerMonthPerYearTotal />
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
